const getters = {
	getNovasExperiencias: (state) => {
		return state.novasExperiencias;
	},

	getMinhasExperiencias: (state) => {
		return state.minhasExperiencias;
	},

	getEncontrosComEspecialista: (state) => {
		return state.encontrosComEspecialista;
	},

	isLoading: (state) => {
		return state.isLoading;
	},

	contemDados: (state) => {
		if (state.novasExperiencias.length || state.minhasExperiencias.length || state.encontrosComEspecialista.length) {
			return true;
		}

		return false;
	},

	getInteresseAlto(state) {
		return state.interesseAlto;
	},

	getInteresseMuitoAlto(state) {
		return state.interesseMuitoAlto;
	},

	isModalVisualizado: (state) => {
		return state.visualizouModalExperiencias;
	},

	getCodigoIes: (state) => {
		return state.codigo_ies;
	},

	getCargaHorariaTotal(state) {
		return state.cargaHorariaTotal;
	},

	getCargaHorariaCursada(state) {
		return state.cargaHorariaCursada;
	},

	isHorarioDisponivel: (state) => (id) => {
		let exp = state.novasExperiencias.find((experiencia) => experiencia.id === id);
		return exp && exp.horarioDisponivel;
	},

	getBloqueio(state) {
		let matriculadas = state.minhasExperiencias.filter((experiencia) => experiencia.vinculo !== undefined && experiencia.vinculo.status === 'matriculado');
		let aprovadas = state.minhasExperiencias.filter((experiencia) => experiencia.vinculo !== undefined && experiencia.vinculo.status === 'aprovado');
		let aguardando = state.minhasExperiencias.filter((experiencia) => experiencia.interesse !== undefined && experiencia.interesse.status === 'aguardando aprovação');

		// para calculo de experiencias totais - maximo 9 - considerar aprovadas e matriculadas sem filtro de data) 
		let contAprov = aprovadas.length;
		let contMatrTotais = matriculadas.length;

		let contMatr = 0;
		let contAguard = 0;

		// para contagem de experiencias e manifestaçoes simultaneas considerar apenas com encontro não realizados
		for (let i = 0; i < matriculadas.length; i++) {
			if (matriculadas[i].horarios !== null && matriculadas[i].horarios !== undefined) {
				for (let j = 0; j < matriculadas[i].horarios.length; j++) {
					// verifica se horario é no futuro
					let dataInicio = new Date(matriculadas[i].horarios[j].data_inicio);
					let agora = new Date();
					if (dataInicio >= agora) {
						contMatr++;
					}
				}
			}
		}

		for (let i = 0; i < aguardando.length; i++) {
			if (aguardando[i].horarios !== null && aguardando[i].horarios !== undefined) {
				for (let j = 0; j < aguardando[i].horarios.length; j++) {
					// verifica se horario é no futuro
					let dataInicio = new Date(aguardando[i].horarios[j].data_inicio);
					let agora = new Date();
					if (dataInicio >= agora) {
						contAguard++;
					}
				}
			}
		}

		if (contAprov + contMatrTotais >= 9) {
			return {
				bloqueio: true,
				motivo: 'Você já atingiu o limite de experiências que seu curso permite.',
			}
		}
		if (contMatr >= 3) {
			return {
				bloqueio: true,
				motivo: 'Você atingiu o limite de matrículas em experiências simultaneamente.',
			}
		}

		if (contAguard + contMatr >= 5) {
			return {
				bloqueio: true,
				motivo: 'Você atingiu o limite de manifestações de interesse permitidas nesta oferta.',
			}
		}
		return {
			bloqueio: false,
			motivo: '',
		}
	}

};

export default getters;
